import { createContext, useMemo } from "react";
import { Outlet } from "react-router";
import Loading from "components/shared/Loading";
import useGraphQLQuery from "hooks/api/GQL";
import queryConfig from "hooks/api/GQL/queryConfig";
import { ILegalAcknowledgementData } from "models/legalAcknowledgement.models";

export type TLegalAcknowledgementContextType = {
  legalAcknowledgements: ILegalAcknowledgementData[] | undefined;
};

export const LegalAcknowledgementContext = createContext<
  TLegalAcknowledgementContextType | undefined
>(undefined);

export const LegalAcknowledgementProvider = () => {
  const { data: legalAcknowledgements, isSuccess } = useGraphQLQuery(
    queryConfig.getLegalAcknowledgements,
  );

  const value = useMemo(
    () => ({ legalAcknowledgements }),
    [legalAcknowledgements],
  );

  return (
    <LegalAcknowledgementContext.Provider value={value}>
      {isSuccess ? <Outlet /> : <Loading />}
    </LegalAcknowledgementContext.Provider>
  );
};
